import { SocialPlatformIcon } from '@app/modules/social-export/components/SocialPlatformIcon';
import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { editCardPublishedOnMessage } from './edit-card-published-platforms-messages';

export interface EditCardPublishedPlatformsLabelProps {
  /** API platform keys with a completed publish (e.g. YOUTUBE). */
  platformKeys: readonly string[];
}

/**
 * Replaces the publish action on generated edits that already have at least one successful publication.
 * Shows a short “published on” prefix plus platform icons (no platform names).
 */
export function EditCardPublishedPlatformsLabel({
  platformKeys,
}: EditCardPublishedPlatformsLabelProps) {
  const { formatMessage: $t } = useIntl();

  const platforms = platformKeys.flatMap((key) => {
    try {
      return [socialPlatforms.get(key)];
    } catch {
      return [];
    }
  });

  if (platforms.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        minWidth: 0,
      }}
    >
      <Typography variant="body2" color="text.secondary" component="span">
        {$t(editCardPublishedOnMessage)}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
        {platforms.map((platform) => (
          <SocialPlatformIcon key={platform.id} platform={platform} size="sm" />
        ))}
      </Box>
    </Box>
  );
}
